import APIRequest from '../core/Request';
//
const sha1 = require('sha1');
//
export default class OrganizationsImportJobSourceFile {
  constructor(API) {
    this.api = API;
  }
  /* Public */
  async uploadAndCreateJob(file, description, jobType = 'ER_SIMPLE_V1') {
    const generatedFileID = this._encodedFileName(file.name);
    //get signed upload file url
    const signedURLResp = await this._createSignURL(generatedFileID, file.type);
    if (signedURLResp.statusCode != 200 || !signedURLResp.body.fileURL) return signedURLResp;
    const signedURL = signedURLResp.body.fileURL;
    //up file
    const uploadResp = await this._uploadRemoteFile(file, signedURL);
    if (uploadResp.statusCode != 200) return uploadResp;
    //create import job
    return this.api.organizationsImportJob.createJob({
      description, importFileID: generatedFileID,
      importFileName: file.name, jobType
    });
  }
  async download(fileID) {
    const signedURLResp = await this._getSignURL(fileID);
    if (signedURLResp.statusCode != 200 || !signedURLResp.body.fileURL) return signedURLResp;
    return this._getRemoteFile(signedURLResp.body.fileURL);
  }
  /* private */
  async _getSignURL(fileID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organizations/importJobs/fileSign/' + fileID;
    return await req.exec();
  }
  async _createSignURL(fileID, fileType) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organizations/importJobs/fileSign/' + fileID + '?type=' + fileType;
    return await req.exec();
  }
  async _getRemoteFile(url) {
    const request = new APIRequest('GET');
    request.baseURL = url;
    request.bodyType = 'BLOB';
    return await request.exec();
  }
  async _uploadRemoteFile(file, url) {
    const req = new APIRequest('PUT');
    req.baseURL = url;

    req.appendHeader('Content-type', file.type);
    req.appendHeader('Content-length', file.file.length);

    req.body = this._dataURItoBlob(file.file);
    req.bodyType = 'BINARY';
    return await req.exec();
  }

  _encodedFileName(filename) {
    return sha1(filename + Date.now() + (Math.random() * 0x3189));
  }
  _dataURItoBlob(dataURI) { //got from https://gist.github.com/davoclavo/4424731
    return Buffer.from(dataURI.replace(/^data:application\/\w+;base64,/, "").replace('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,', ''), 'base64');
  }
}
